export default __webpack_public_path__ + "static/media/sport_icon.f991f72c.svg";